/**
 * Window events the saved moment listens for, in the same style as the
 * editor's other `lilia:*` events (open-history-rail, save-now, …): the
 * indicator sits in the shell bar and must not import the editor to hear it.
 */

/** A named version was cut. EditorPage's ⌘S and the card both end here. */
export const VERSION_SAVED_EVENT = "lilia:version-saved";

/** Ask the open editor to cut a named version (the card's Save a version…). */
export const SAVE_VERSION_EVENT = "lilia:save-version";

export interface VersionSavedDetail {
  documentId: string;
  name: string;
  createdAt: string;
}

export interface SaveVersionDetail {
  /** Blank or missing: the server names it ("Version 4"). */
  name?: string | null;
}

export function requestSaveVersion(detail: SaveVersionDetail = {}): void {
  window.dispatchEvent(new CustomEvent<SaveVersionDetail>(SAVE_VERSION_EVENT, { detail }));
}
